import { render, staticRenderFns } from "./LicenseBindGoods.vue?vue&type=template&id=5906aaa9&scoped=true&"
import script from "./LicenseBindGoods.vue?vue&type=script&lang=ts&"
export * from "./LicenseBindGoods.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5906aaa9",
  null
  
)

export default component.exports